import { Navigate, Outlet, useLocation } from "react-router";
import { EmptyState } from "@/components/ui/states";
import { useProject } from "./hooks";

export function ProjectRoute() {
  const { can } = useProject();
  const { pathname } = useLocation();
  const section = pathname.split("/")[1] ?? "";
  if (!can("experiments:read") && (!section || section === "agents" || section === "compare"))
    return <Navigate to="/annotation" replace />;
  const resource = section === "annotation" ? "annotations" : section;
  if (["agents", "experiments", "datasets", "evaluators", "annotations"].includes(resource)) {
    const creating = pathname.endsWith("/new") || pathname.endsWith("/import");
    if (!can(`${resource}:${creating ? "write" : "read"}`))
      return <EmptyState title="You do not have access to this page" />;
  }
  return <Outlet />;
}
